import PropTypes from 'prop-types';
import React from 'react';
import { Body3 } from '../../text/Text';
import style from './MultiSwitch.module.css';

export const MultiSwitch = ({
  labels,
  values,
  setValue,
  controlledValue,
  margin,
  justifyContent,
  title
}) => {
  return (
    <div className={style.container} title={title} style={{ margin, justifyContent }}>
      {labels.map((label, index) => {
        const value = values[index]; 

        let styleObj;
        if (index === 0)
          styleObj = {
            borderRadius: '3px 0 0 3px',
            borderRight: '1px solid var(--color-grey)',
          };
        else if (index === labels.length - 1)
          styleObj = { borderRadius: '0 3px 3px 0' };
        else
          styleObj = {
            borderRight: '1px solid var(--color-grey)',
          };

        return (
          <div
            key={label}
            style={styleObj}
            className={
              controlledValue === value ? style.selected : style.notSelected
            }
            onClick={() => setValue(value)}
          >
            <Body3 fontWeight={600} margin="0">
              {label}
            </Body3>
          </div>
        );
      })}
    </div>
  );
};

MultiSwitch.propTypes = {
  controlledValue: PropTypes.any,
  labels: PropTypes.array.isRequired,
  margin: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
  justifyContent: PropTypes.string,
  title: PropTypes.string,
};
